export default function isSmoothManifestLive(manifestText: string) {
  try {
    const parser = new DOMParser();
    const parsed = parser.parseFromString(manifestText, 'text/xml');
    if (parsed) {
      const elem = parsed.getElementsByTagName('SmoothStreamingMedia')[0];
      const attr = elem && elem.attributes.getNamedItem('IsLive');
      const isLive = attr && attr.value;
      if (isLive) {
        return isLive.toLowerCase() === 'true';
      } else {
        // if the IsLive field is not in the element, then the manifest is VOD
        return false;
      }
    }
    // Error on the side of reporting as LIVE
    return true;
  } catch (e) {
    // Improperly formatted DASH manifest
    // Error on the side of reporting as LIVE
    return true;
  }
}
